module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/main_pc_9e6218d4213bb692a27f9585b3cdb71b.jpg";